import { useLayoutEffect } from 'react';

export default function useClientRect(cb, ref, dependencies = []) {
  useLayoutEffect(() => {
    const observer = new ResizeObserver(entries => {
      if (!Array.isArray(entries) || !entries.length) {
        return;
      }
      const entry = entries[0];
      const rect = entry.target.getBoundingClientRect().toJSON();
      cb(rect);
    });
    observer.observe(ref.current);
    return () => {
      observer.disconnect();
    };
  }, dependencies);
}
